import { FC } from 'react'

import { Box, ProgressBar, Section, Text } from '@factorialco/deprecated-design-system'
import { truncate } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { MaterializedProcess } from 'modules/processes/domain'
import type { Process } from 'modules/processes/hooks/useProcesses'

import { boxWrapper } from './index.vanilla.css'

interface Props {
  process: Process
  materializedProcess: MaterializedProcess
}

type ProcessProgressInsights = {
  totalTasks: number
  totalCompletedTasks: number
  totalPendingTasks: number
}

const ProgressIndicators: FC<{ currentStepData: ProcessProgressInsights }> = ({
  currentStepData,
}) => {
  return (
    <Box flexDirection="column" width="full">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Box width="full">
          <Text.Normal>{i18n.t('processes.materialize_process.detail.task_done')}</Text.Normal>
        </Box>
        <ProgressBar
          progressColor="viridian1000"
          amount={currentStepData.totalCompletedTasks}
          total={currentStepData.totalTasks}
        />
      </Box>
      <Box flexDirection="row" gap="s2">
        <Box width="full">
          <Text.Normal>{i18n.t('processes.materialize_process.detail.task_pending')}</Text.Normal>
        </Box>
        <ProgressBar
          barColor="champagne200"
          progressColor="champagne1000"
          amount={currentStepData.totalPendingTasks}
          total={currentStepData.totalTasks}
        />
      </Box>
    </Box>
  )
}

const PageHeader = ({ process, materializedProcess }: Props) => {
  const totalTasks = materializedProcess.totalResources ?? 0
  const totalCompletedTasks = materializedProcess.completedResources ?? 0
  const totalPendingTasks = totalTasks - totalCompletedTasks

  const insights = {
    totalTasks,
    totalCompletedTasks,
    totalPendingTasks,
  }

  return (
    <Section
      paddingX="s0"
      title={materializedProcess.name}
      description={truncate(process.description ?? '', { length: 150 })}
    >
      <Box
        padding="s16"
        borderRadius={{
          all: 'abs006',
        }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        className={boxWrapper}
      >
        <ProgressIndicators currentStepData={insights} />
      </Box>
    </Section>
  )
}

export default PageHeader
